import { Link } from 'react-router-dom'
import { ArticleTag } from '../HomePage/ArticleTag'
import {
  articelsHomePageImages,
  postListNewImages,
} from '../../services/images.service'
import { formatHebrewDate } from '../../services/util.service'
import { PostAuthorLine } from './PostAuthorLine'
import { CommentIcon, HeartIcon } from '../ui/icons/shared'

export function MostCommentPost({ posts, authorMap }) {
  const mostCommentedPosts = posts
    .filter((post) => typeof post.commentCount === 'number') // משתמשים ב-commentCount
    .sort((a, b) => b.commentCount - a.commentCount) // מיון לפי commentCount
    .slice(0, 6)

  return (
    <section className="container mx-auto">
      <h2 className="text-2xl mb-4">המדוברים ביותר</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {mostCommentedPosts.map((post) => {
          return (
            <div key={post._id} className="mt-5 relative">
              <Link to={`/post/${post._id}`}>
                {post.imageUrl && (
                  <div
                    className="w-full aspect-[16/9] max-h-[220px] overflow-hidden mb-4"
                    aria-label={`תמונה מתוך הפוסט: ${post.title}`}
                  >
                    <img
                      src={post.imageUrl}
                      alt={`תמונה מתוך הפוסט: ${post.title}`}
                      title={post.title}
                      className="w-full h-full object-cover"
                      loading="lazy"
                      decoding="async"
                      srcSet={`
        ${post.imageUrl}?w=600 600w,
        ${post.imageUrl}?w=1280 1280w
      `}
                      sizes="(max-width: 768px) 100vw, 768px"
                    />
                  </div>
                )}

                <div className="absolute -translate-y-[90%] right-4">
                  <ArticleTag tags={post.tags} />
                </div>
              </Link>

              <div className="flex flex-col gap-2 mt-8">
                <h3 className="text-xl text-white max-w-[320px]">
                  <Link to={`/post/${post._id}`}>{post.title}</Link>
                </h3>
                <PostAuthorLine
                  userId={post.author?.userId}
                  createdAt={post.createdAt}
                />

                <div className="flex items-center gap-6">
                  <div className="flex gap-2">
                    <CommentIcon />
                    <span className="text-white">{post.commentCount ?? 0}</span>
                  </div>
                  <div className="flex gap-2">
                    <HeartIcon />
                    <span className="text-white">{post.likes.length}</span>
                  </div>
                </div>
              </div>
            </div>
          )
        })}
      </div>
      <img
        className="w-full my-24"
        src={postListNewImages.longLineDivider}
        alt="Divider"
      />
    </section>
  )
}
